import { useQuery } from 'react-query'

import { legalEntityQueryConfig } from '@webapp/platform/legal-entities/query-configs/legalEntityQueryConfig'

interface LegalEntityUniqueFields {
  names: string[]
  externalIds: string[]
}

/**
 * The names and (non-empty) external IDs of every existing LegalEntity
 * (active + inactive), used for the client-side duplicate checks on create and
 * edit. Both must be unique per org.
 *
 * Reuses the shared `list` query config, so it shares the list view's cached
 * request rather than triggering an extra one.
 */
export const useQueryLegalEntityUniqueFields = (): LegalEntityUniqueFields => {
  const { data } = useQuery(legalEntityQueryConfig.list())

  const entities = data ?? []

  return {
    names: entities.map((entity) => entity.name),
    // External ID is optional, so ignore blanks — only set values must be unique.
    externalIds: entities
      .map((entity) => entity.externalId)
      .filter((externalId) => externalId.trim().length > 0),
  }
}
